/**
 * round.ts — the round life cycle and the scoreboard everyone reads on Tab.
 *
 * A room is either warming up or running rounds. In a round, death is FINAL:
 * once one duelist is left standing the round is theirs, everyone comes back,
 * and the next round begins. That is what makes a swing matter — a timed
 * respawn mid-round would turn every duel into an endless brawl.
 *
 * Warmup exists because a room with one person in it has nobody to be the last
 * one standing against, so "one alive" cannot mean anything there. Below
 * `MIN_ROUND_PLAYERS` the room idles instead, and death falls back to the
 * `RESPAWN_MS` timer so a lone player can still practise.
 *
 * The phase is server state like everything else (AGENTS.md: server-authoritative): the
 * client is told what round it is and what the scores are, and never decides.
 */
/** Players a room needs before rounds are worth running. */
export const MIN_ROUND_PLAYERS = 2;
/** No winner: a double knockout, or a round abandoned because someone left. */
export const NO_WINNER = -1;
/**
 * Decides a live round from nothing but the head count. Pure, so the rule that
 * ends a round is testable without a world, a physics engine or a clock.
 */
export function judgeRound(present, aliveSlots) {
    if (present < MIN_ROUND_PLAYERS)
        return { kind: 'abandon' };
    if (aliveSlots.length > 1)
        return { kind: 'continue' };
    return { kind: 'over', winner: aliveSlots[0] ?? NO_WINNER };
}
/** Scoreboard order: round wins, then kills, then fewest deaths, then slot. */
export function compareScores(a, b) {
    return b.wins - a.wins || b.kills - a.kills || a.deaths - b.deaths || a.slot - b.slot;
}
//# sourceMappingURL=round.js.map